import { useState } from "react";
import { ChatbotInput } from "../components/inputs/chatbot-input";
import { z } from "zod";
import "../../assets/fa-icons/css/fontawesome.css";
import "../../assets/fa-icons/css/sharp-solid.css";

interface InputSectionProps {
  handleSendMessage(text: string): void;
}

const outerContainer =
  "flex flex-col w-full justify-end p-4 gap-4 self-stretch bg-cloud border-solid border-t border-t-foggy-firth rounded-b-lg";
const innerContainer = "flex gap-2.5 self-stretch min-h-[42px]";
const iconContainer =
  "flex w-[25px] justify-center items-center text-loch disabled:text-neutral-300 disabled:cursor-not-allowed max-h-[42px]";

// Zod schema for message validation
const messageSchema = z.string().min(1, "").max(1000, "Maximum 1000 charaters");

export const PropertyPalInputSection: React.FC<InputSectionProps> = (props) => {
  const [value, setValue] = useState("");
  const [error, setError] = useState<string | null>(null);
  const isSubmitDisabled = value.trim().length === 0 || error != null;

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;

    // Check message length and set error if invalid
    const result = messageSchema.safeParse(newValue);
    setError(result.success ? null : result.error.errors[0].message);

    setValue(newValue);
  };

  const onSubmit = () => {
    if (!isSubmitDisabled) {
      props.handleSendMessage(value);
      setValue(""); // Optionally clear input after sending
    }
  };

  // Handle Enter key press
  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter" && !isSubmitDisabled) {
      e.preventDefault();
      onSubmit();
    }
  };

  return (
    <div className={outerContainer}>
      <div className={innerContainer}>
        <ChatbotInput
          state={error ? "error" : "default"}
          id="userInput"
          placeholder="Type your question here 😊"
          value={value}
          onChange={handleInputChange}
          onKeyDown={handleKeyDown}
          aria-invalid={!!error}
          message={error ?? ""}
        />

        <button
          type="button"
          onClick={onSubmit}
          disabled={isSubmitDisabled}
          className={iconContainer}
          aria-label="Send message"
        >
          <i className="fa-sharp fa-solid fa-paper-plane-top text-[25px]" aria-hidden="true" />
        </button>
      </div>
    </div>
  );
};
